import { Grid } from '@material-ui/core';
import { rhythm } from 'Themes/typography';
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import PreviewImageModal from 'PreviewImageModal';
// import dompurify from 'dompurify';

const NoteNumb = styled.span`
  color: black;
  font-weight: bold;
`;
const Note = styled.p`
  display: block !important;
`;

import { ASSETS_ROUTE } from 'Api/Routes.js';

const Container = styled.div`
  padding: ${rhythm(1.5)} 0;
  border-top: 2px solid ${({ theme }) => theme.palette.blue.light};
  border-bottom: 2px solid ${({ theme }) => theme.palette.blue.light};
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;
const ContainerThirdStep = styled.div`
  padding: ${rhythm(0.1)} 0;
  display: flex;
  align-items: center;
`;

const Image = styled.img`
  // width: 100%;
  max-width: 100%;
  height: auto;
  margin: 0;
`;

const Heading = styled.h1`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: ${rhythm(1)};
`;
const HeadingThirdStep = styled.h1`
  font-size: 1rem;
  font-weight: 600;
  border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
  padding: ${rhythm(0.1)} 0;
  margin-bottom: ${rhythm(0.3)};
`;

const Notes = styled.div`
  word-break: break-all;
`;

class PhotosAndNotes extends Component {
  state = {
    preview: false,
    activeAsset: null,
  };

  openPreview = asset => () => {
    this.setState({
      preview: true,
      activeAsset: asset,
    });
  };

  closePreview = () => {
    this.setState({
      preview: false,
      activeAsset: null,
    });
  };

  separateNotes = note => {
    const checkIfCanDecode = item => {
      try {
        const decode = decodeURI(item);
        return decode;
      } catch (err) {
        return item;
      }
    };
    if (note) {
      // const sanitizer = dompurify.sanitize;
      // let noteSanitizer = sanitizer(note);
      let noteSanitizer = note;
      let split = noteSanitizer.split('_$_');
      return split.map((el, index) => (
        <Note key={index}>
          <NoteNumb>{index + 1 + '. '}</NoteNumb> {checkIfCanDecode(el)}
        </Note>
      ));
    }
  };

  renderPhotos = (shortlisted, assets, note) => {
    return (
      <Grid spacing={16} container>
        <Grid item xs={12} md={shortlisted ? 12 : 6}>
          {shortlisted ? (
            <HeadingThirdStep>Photos</HeadingThirdStep>
          ) : (
            <Heading>Photos</Heading>
          )}
          <Grid spacing={16} container>
            {assets.map(asset => {
              return (
                <Grid key={asset} item xs={12} md={shortlisted ? 4 : 6}>
                  <Image
                    onClick={this.openPreview(asset)}
                    src={`${ASSETS_ROUTE}${asset}`}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        {shortlisted ? null : (
          <Grid item xs={12} md={6}>
            <Heading>Notes</Heading>
            <Notes>{this.separateNotes(note)}</Notes>
          </Grid>
        )}
      </Grid>
    );
  };

  render() {
    const { note = '', assets = [], shortlisted = false } = this.props;

    return (
      <Fragment>
        {!shortlisted ? (
          <Container>{this.renderPhotos(shortlisted, assets, note)}</Container>
        ) : assets.length === 0 ? null : (
          <ContainerThirdStep>
            {this.renderPhotos(shortlisted, assets, note)}
          </ContainerThirdStep>
        )}
        <PreviewImageModal
          open={this.state.preview}
          onClose={this.closePreview}
          image={this.state.activeAsset}
        />
      </Fragment>
    );
  }
}

export default PhotosAndNotes;
